

(function(){
    angular.module('tmx-app').factory('GeofenceService', ['tmxResource','LocationService', function(tmxResource,LocationService){


        var GeoFences = tmxResource("Geofence");

        LocationService.lov().then(function(result){
            GeoFences.gridColumn[2].data = result.data;
            GeoFences.recievedLov=true;            
            GeoFences.locations = result.data;
        });
      
        GeoFences.gridColumn = [
                        
            {
                field: "LocationName",
                title: "Location Name",
                type: "text",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : GeoFenceCtrl.isFiltered('LocationName')}\" >Location Name <i class='fa fa-filter' ng-if='GeoFenceCtrl.isFiltered(\"LocationName\")' ></i></span>"
            },
            {
                field: "LocationCode",
                title: "Location Code",
                type: "text",
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : GeoFenceCtrl.isFiltered('LocationCode')}\" >Location Code<i class='fa fa-filter' ng-if='GeoFenceCtrl.isFiltered(\"LocationCode\")' ></i></span>"
            },          
            {
                field: "GeofenceCount",
                title: "Geofence Count",
                type: "integer",                
                search: true                
            },
            {
                
            }                
        ];


        GeoFences.columns = [
                        
            {
                field: "GeofenceName",
                title: "Geofence Name",
                type: "string",              
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : GeoFenceCtrl.isFiltered('GeofenceName')}\" >Geofence Name <i class='fa fa-filter' ng-if='GeoFenceCtrl.isFiltered(\"GeofenceName\")' ></i></span>"
            },
            {
                field: "GeofenceCode",
                title: "Geofence Code",
                type: "string",             
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : GeoFenceCtrl.isFiltered('GeofenceCode')}\" >Geofence Code<i class='fa fa-filter' ng-if='GeoFenceCtrl.isFiltered(\"GeofenceCode\")' ></i></span>"
            },          
            {                
                field: "LocationId",
                title: "Location",
                type: "string",
                data: GeoFences.locations,                
                filterable: {
                    ui: locationFilter,
                    extra: false,               
                operators: {
                    string: {                        
                        eq: "Is equal to",
                        neq: "Is not equal to"
                    }
                }
               },
                search: true,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : GeoFenceCtrl.isLocationFiltered('LocationId')}\" >Location <i class='fa fa-filter' ng-if='GeoFenceCtrl.isLocationFiltered(\"LocationId\")' ></i></span>"                
            }                  
        ];
        

        function locationFilter(element) {            
            element.kendoDropDownList({
                dataSource: GeoFences.locations,
                optionLabel: "--Select Value--",
                dataTextField: "VisibleValue",
                dataValueField: "HiddenValue"
            });
        }      
        
        return GeoFences;

    }]);
})();